import React from "react";
import Card from "../card/Card";
import UploadBox from "../uploadbox/UploadBox";
import { ProgressBar } from "react-loader-spinner";
import GallerySlideshowSettings from "../gallery/GallerySlideshowSettings";
import "./MemorialGallery.css";

function MemorialGallery({
  memorial,
  selectedPlan,
  selectedTheme,
  subMenu,
  setSubMenu,
  loading,
  handleFileInputChange,
  onSlideshowUpdate,
  isAdmin = false,
}) {
  const textColor = selectedTheme?.textColor || "#5c5470";
  const photos = memorial?.gallery?.photos || [];
  const freePhotoLimit = 5;
  const canUploadPhoto =
    isAdmin && (selectedPlan === 0 ? photos.length < freePhotoLimit : true);

  const tabs = [
    { id: "photo", label: "Photo" },
    ...(selectedPlan !== 0 && selectedPlan != null
      ? [
          { id: "video", label: "Video" },
          { id: "audio", label: "Audio" },
        ]
      : []),
  ];

  const photoSection = (
    <>
      {subMenu === "photo" && isAdmin && (
        <GallerySlideshowSettings
          memorial={memorial}
          selectedPlan={selectedPlan}
          textColor={textColor}
          onUpdate={onSlideshowUpdate}
          showPreview={false}
        />
      )}
      {canUploadPhoto && (
        <>
          <p className="section-text">Add a Photo</p>
          <UploadBox device={true} handleFileInputChange={handleFileInputChange} />
        </>
      )}
      {isAdmin && selectedPlan === 0 && !canUploadPhoto && (
        <p className="section-text">Free plan limit: {freePhotoLimit} photos.</p>
      )}
      <div className="gallery memorial-gallery-media">
        {!loading ? (
          photos.map((url, index) => (
            <div key={index} className="gallery-item">
              <img src={url} alt={`Gallery ${index + 1}`} />
            </div>
          ))
        ) : (
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <ProgressBar
              height="80"
              width="80"
              ariaLabel="progress-bar-loading"
              wrapperClass="progress-bar-wrapper"
              borderColor={textColor}
              barColor={textColor}
            />
            <p style={{ color: textColor, fontSize: "10px" }}>Uploading ...</p>
          </div>
        )}
      </div>
    </>
  );

  const videoSection = (
    <>
      {isAdmin && (
        <>
          <p className="section-text">Add a Video</p>
          <UploadBox device={true} handleFileInputChange={handleFileInputChange} />
        </>
      )}
      <div className="gallery memorial-gallery-media">
        {!loading ? (
          (memorial?.gallery?.videos || []).map((url, index) => (
            <div key={index} className="gallery-item">
              <video src={url} controls />
            </div>
          ))
        ) : (
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <ProgressBar height="80" width="80" borderColor={textColor} barColor={textColor} />
          </div>
        )}
      </div>
    </>
  );

  const audioSection = (
    <>
      {isAdmin && (
        <>
          <p className="section-text">Add Audio</p>
          <UploadBox device={true} handleFileInputChange={handleFileInputChange} />
        </>
      )}
      <div className="gallery memorial-gallery-media">
        {!loading ? (
          (memorial?.gallery?.audios || []).map((url, index) => (
            <div key={index} className="gallery-item">
              <audio src={url} controls />
            </div>
          ))
        ) : (
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <ProgressBar height="80" width="80" borderColor={textColor} barColor={textColor} />
          </div>
        )}
      </div>
    </>
  );

  const menuContent = {
    photo: photoSection,
    video: videoSection,
    audio: audioSection,
  };

  return (
    <Card Width="100%">
      <div className="memorial-gallery">
        <nav className="memorial-gallery-tabs" aria-label="Gallery media type">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              type="button"
              onClick={() => setSubMenu(tab.id)}
              className={`memorial-gallery-tab${subMenu === tab.id ? " active" : ""}`}
              style={subMenu === tab.id ? { color: textColor, borderBottomColor: textColor } : undefined}
            >
              {tab.label}
            </button>
          ))}
        </nav>
        <div className="memorial-gallery-content">{menuContent[subMenu] || photoSection}</div>
      </div>
    </Card>
  );
}

export default MemorialGallery;
